import { ICourseCatalogLandingPageCategorySectionQuery } from '../interfaces/course-catalog-landing-page-category-section.query.interface';
import { CourseCatalogPostingStream } from './course-catalog-posting-stream.model';
import { CourseCatalogCategoryType } from 'app/library/course-catalog/enums/course-catalog-category-type.enum';

// @dynamic
export class CourseCatalogLandingPageCategorySection {
    id: string;
    name: string;
    type: CourseCatalogCategoryType = CourseCatalogCategoryType.UNINITIALIZED;
    postingStream?: CourseCatalogPostingStream[];

    constructor(query: ICourseCatalogLandingPageCategorySectionQuery) {
        this.id = query.id.toString();
        this.name = query.name;
        this.type = query.type ?? CourseCatalogCategoryType.UNINITIALIZED;
    }
}
